import type { FeedbackMessages } from './en';

const nl: FeedbackMessages = {
  qualified: {
    title: 'Bedankt voor het voltooien van dit onderzoek!',
    text: 'U kunt het browservenster nu sluiten.\n\nWe hopen u snel weer te zien.',
  },
  quotaFull: {
    title: 'Dit onderzoek is gesloten',
    text: 'Bedankt voor uw interesse in ons onderzoek.\n\nHelaas hebben we al alle benodigde reacties ontvangen.\n\nWe hopen u in een van onze toekomstige onderzoeken te zien!',
  },
  terminated: {
    title: 'Bedankt voor het delen van uw feedback!',
    text: 'We hopen u binnenkort weer te zien in een van onze toekomstige onderzoeken. Tot die tijd wensen we u een fijne dag.\n\nSluit dit browservenster.',
  },
  mismatch: {
    title: 'Bedankt voor uw interesse',
    text: 'Helaas behoort u niet tot de doelgroep voor dit specifieke onderzoek.\n\nU kunt deze pagina sluiten.',
  },
  error: {
    title: 'We kunnen uw verzoek niet verwerken',
    linkProblemDetailed:
      'Er is een probleem met de link die u heeft gevolgd. Controleer of de link in de adresbalk overeenkomt met de link die u heeft gekregen en probeer het opnieuw.',
    linkProblemGeneric:
      'Er is een probleem met de link die u heeft gevolgd. Probeer het opnieuw.',
    contactPerson:
      'Als het probleem aanhoudt, laat dit dan weten aan de persoon van wie u de link heeft gekregen.',
  },
};

export default nl;
